import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { connect, Provider } from 'react-redux';
import { bindActionCreators } from 'redux';
import deepMerge from 'lodash/merge';
import * as _ from '../lodash';
import appointmentWidgetPage from '../page/AppointmentWidgetPage';
import store from '../configureStore';
import { Product } from '../types';
import * as productActions from '../actions/products';
import * as frameActions from '../actions/frames';
import * as orderActions from '../actions/orders';
import * as settingActions from '../actions/settings';
import * as cartActions from '../actions/cart';

const mapStateToProps = ({
  settings, product, order, frames: { timeslots, frames, ...framesProps },
}) => ({
  frames,
  order,
  timeslots,
  ...framesProps,
  ...settings,
  locale: window.bta.locale.substr(0, 2),
  isDemo: window.bta.isDemo,
  timeZone: window.bta.timeZone,
  googleApiKey: window.bta.googleApiKey,
  locations: product.data.locations,
  resources: product.data.resources,
  minDate: product.data.mindate,
  maxDate: product.data.maxdate,
  variants: product.data.variants,
  productTitle: product.data.title,
  capacity: product.data.capacity,
});

const mapDispatchToProps = dispatch => ({
  frameActions: bindActionCreators({ ...frameActions }, dispatch),
  orderActions: bindActionCreators({ ...orderActions }, dispatch),
  cartActions: bindActionCreators({ ...cartActions }, dispatch),
});

const AppointmentWidgetPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(appointmentWidgetPage);

export default class AppointmentWidgetContainer extends Component {
  UNSAFE_componentWillMount() {
    let { settings, product, defaultTranslation, exceededTrialPlan } = this.props;

    const newStyle = window.xprops.data && window.xprops.data.style;

    if (newStyle) {
      settings = deepMerge(settings, { style: newStyle });
    }

    if (window.xprops && window.xprops.onInit) {
      window.xprops.onInit(settings.setting);
    }

    store.dispatch(
      settingActions.setConfiguration({
        ...settings,
        defaultTranslation,
        exceededTrialPlan
      }),
    );

    // here get data from api originally, later change to get from rails
    store.dispatch(productActions.fetchProduct(product)).then(() => {
      if (product.variants.length > 0) {
        store.dispatch(
          orderActions.setVariantsQuantity(`${product.variants[0].external_id}_quantity`, 1, { singleVariant: true }),
        );
      }
      // if (product.resources.length > 0) {
      //   store.dispatch(
      //     orderActions.setSelectedResource(product.resources[0]),
      //   );
      // }
      // if (product.locations.length > 0) {
      //   store.dispatch(
      //     orderActions.setSelectedLocation(product.locations[0]),
      //   );
      // }
    });
  }

  componentDidMount() {
    const {
      settings: { setting },
      product,
      exceededTrialPlan
    } = this.props;

    if (window.xprops && window.xprops.onInit) {
      window.xprops.onInit(setting);
    }
    const date = new Date();
    const start = new Date(date.getFullYear(), date.getMonth(), 1);
    const finish = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const externalId = (product.variants[0] || {}).external_id;
    const interval = parseInt(setting.interval, 10)
    const intervalUnit = setting.interval_unit || 'hours';
    const intervalUnitMultiplier = intervalUnit == 'minutes' ? 1 : 60;
    const intervalValue = isNaN(interval) ? null : interval*intervalUnitMultiplier;

    if (externalId) {
      if (!exceededTrialPlan) store.dispatch(frameActions.fetchBlocks(externalId, start, finish, null, null, intervalValue));
    } else {
      console.log('External ID not found');
    }
  }

  render() {
    return (
      <div>
        <Provider store={store}>
          <AppointmentWidgetPage />
        </Provider>
      </div>
    );
  }
}

window.changeStyle = value => store.dispatch(settingActions.setStyle(value));
window.changeTranslation = (key, value) => {
  store.dispatch(settingActions.setTranslation(key, value));
};
window.changeSetting = (key, value) => store.dispatch(settingActions.setSetting(key, value));

AppointmentWidgetContainer.propTypes = {
  defaultTranslation: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
};
